(function (){
    'use strict';

    angular
        .module('platformRental', [
            'ui.router',
            'ui.bootstrap',
            'ngDialog',
            'ui.select',
            'ngSanitize',
            'vAccordion',
            'ngAnimate',
            'ui.footable',
            'angular.morris',
        ]);
})();